import getSymbolFromCurrency from "currency-symbol-map";
import { useAtom } from "jotai";
import Card from "react-bootstrap/Card";
import { animated } from "react-spring";
import { pushGTMAnalyticsEvent } from "../../../modules/pushGTMAnalyticsEvent";
import { items_state, products_state, update_items_activeIds } from "../../dataManagers/GlobalDataManagers";
import { Boop } from "../Animations/Boop";
import { ImgWithFallback } from "../ImgWithFallback/ImgWithFallback";

export const CardItem = ({ component, item, animation }) => {
  const [itemsState] = useAtom(items_state);
  const [productsState] = useAtom(products_state);
  const [, setItemsActiveIds] = useAtom(update_items_activeIds);
  const isActive = itemsState.activeIds[component._id]._id === item._id;
  const displayPrice = item.price > 0;

  const handleClick = () => {
    // abort if active item was reclicked
    if (itemsState.activeIds[component._id]._id === item._id) return;

    let copy = { ...itemsState.activeIds };
    copy[component._id] = { _id: item._id };

    setItemsActiveIds(copy);

    pushGTMAnalyticsEvent({
      event: "Item Click - Thrill",
      category: component.category,
      itemSection: component.displayName,
      item: item.displayName,
    });
  };

  return (
    <animated.div style={animation}>
      <Boop boopType="scale" scale={1.02} timing={200}>
        {isActive && <img className="checkMark" alt="check mark" src="/images/checkmark.svg" />}
        <Card onClick={() => handleClick(item._id)} className={`cardItem mx-auto mb-3 ${!isActive && "disabled"}`}>
          {displayPrice && isActive && (
            <p className="priceBlack imagePricePosition">{`${getSymbolFromCurrency(
              productsState.activeObj?.shopify?.currency?.active ?? "USD"
            )}${item.price}`}</p>
          )}
          <div className={`d-flex mx-auto mb-2 imgFrame zoomed`}>
            {item?.thumbnail ? (
              <ImgWithFallback
                className={`card-img-top mx-auto my-auto imageCard ${component.category}`}
                src={item.thumbnail[0]}
                fallback={item.thumbnail[1] || item.thumbnail[0]}
                onClick={handleClick}
              />
            ) : (
              <h4 className="my-auto">{item?.cardText}</h4>
            )}
          </div>
          <Card.Body className="p-0">
            <Card.Title className="text-center">{item.displayName}</Card.Title>
          </Card.Body>
        </Card>
      </Boop>
    </animated.div>
  );
};
